import { Box, Stack, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useTheme } from "@mui/material/styles";

import { useResponsive } from "@app/hooks";
import { Strings } from "@app/constants";
import { IModelData } from "../types";
import { RowActions } from "./row-actions";
import { deleteModel } from "../slice";
import { AddModelModal } from "./add-model";

interface Props {
  item: IModelData;
}

export const ModelCard = ({ item }: Props) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const { id, image, name, brand } = item;
  const isTab = useResponsive("between", "sm", "md");

  const fontFamily = Strings.fontLanguage.workSans;

  const [editModelDialog, setEditModelDialog] = useState<boolean>(false);

  const handleDelete = () => {
    if (id) {
      dispatch(deleteModel({ modelId: id }));
    }
  };

  return (
    <>
      <Box
        key={id}
        sx={{
          width: isTab ? "205px" : "233px",
          alignItems: "center",
          justifyContent: "center",
          "&:hover .row-actions": {
            visibility: "visible",
          },
        }}
      >
        <Stack
          sx={{
            position: "relative",
            width: "100%",
            height: 200,
            border: 1,
            borderColor: "#ACCFF4",
            background: "linear-gradient(180deg, #F8FBFF 0%, #D3E6F8 100%)",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          {/* Row actions (Edit/Delete buttons) */}
          <Stack
            direction="row"
            justifyContent="flex-end"
            className="row-actions"
            sx={{
              visibility: "hidden",
              transition: "visibility 0.2s ease-in-out",
              position: "absolute",
              right: 5,
              top: 10,
              p: 0.5,
              backgroundColor: theme.palette.common.white,
              borderRadius: 1,
            }}
          >
            <RowActions handleEdit={() => setEditModelDialog(true)} />
          </Stack>

          {/* Image */}
          <img
            src={image ?? brand?.image ?? ""}
            alt={name}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Stack>

        {/* Model Name */}
        <Typography
          mt={2}
          fontWeight={700}
          variant="body1"
          fontFamily={fontFamily}
          width={"100%"}
          textAlign={"center"}
          color={theme.palette.grey[700]}
        >
          {name}
        </Typography>

        {/* Brand Name */}
        {brand?.name && (
          <Typography
            variant="body2"
            fontFamily={fontFamily}
            textAlign="center"
            color={theme.palette.grey[500]}
          >
            {brand.name}
          </Typography>
        )}
      </Box>

      {/* Edit Modal */}
      {editModelDialog && (
        <AddModelModal
          open
          onClose={() => {
            setEditModelDialog(false);
          }}
          selectedBrandData={item}
        />
      )}
    </>
  );
};
